export default __webpack_public_path__ + "static/media/besos-cafe.fb73e48c.jpg";